<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="flex items-center"
            v-if="!modeTemplate"
          >
            <input
              class='k-checkbox !mr-2 checkbox-lg'
              type='checkbox'
              v-model="checkall"
              @click="changeAllCheckbox(!checkall)"
            />
            <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">Marcar todos los campos</label>
          </div>
          <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('companies.group_company_data')}}</h2>
          <div class="lg:mb-2">
            <div class="flex items-center">
              <input
                v-if="!modeTemplate"
                class='k-checkbox !mr-2 checkbox-lg'
                type='checkbox'
                v-model="valuesCheckbox.fechaInicioVig"
              />
              <div>
                <div class="flex flex-row items-center mb-1">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('companies.date_vigilante')}}</label>
                  <base-tooltip-icon size="sm" :content="tooltipfechaInicioVig" class="ml-2"/>
                </div>
                <el-form-item prop="fechaInicioVig">
                  <el-date-picker
                    :clearable="false"
                    :aria-label="$t('companies.date_vigilante')"
                    class="bg-white dark:bg-darkblue-900"
                    v-model="form.fechaInicioVig"
                    :picker-options="dateRangeOptions"
                    type="date"
                    format="dd-MM-yyyy"
                    placeholder="dd-mm-aaaa"
                    ref="datePickerFechaaInicioVig"
                    @blur="onBlurDatePickerMixin('.datePickerFechaaInicioVig-popover')"
                    @focus="onFocusDatePickerMixin('.datePickerFechaaInicioVig-popover')"
                    @keydown.native="captureKeyNotChrome"
                    popper-class="datePickerFechaaInicioVig-popover"
                    >
                  </el-date-picker>
                </el-form-item>
              </div>
              <base-clear-input-button
                v-if="form.fechaInicioVig"
                aria-label="Limpiar fecha"
                @clear="form.fechaInicioVig = null"
              />
            </div>
          </div>
          <div class="lg:mb-6">
            <div class="mandatory flex items-center">
              <input
                v-if="!modeTemplate"
                class='k-checkbox !mr-2 checkbox-lg'
                type='checkbox'
                v-model="valuesCheckbox.Activo"
              />
              <label for="switch-activo" class="sr-only">
                {{$t('configurations.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.active')}}
              </label>
              <el-switch 
                id="switch-activo"
                :aria-label="$t('configurations.active')"
                class="switch-text break-normal" 
                v-model="form.Activo" 
                :active-text="$t('configurations.active')"></el-switch>
            </div>
          </div>

          <!-- <h2 class="dark:text-darkblue-200 font-bold mt-8 mb-4">{{$t('companies.group_alert')}}</h2> -->

          <base-collapsible-form 
              ref="baseCollapsibleGroupAlert" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.group_alert')}}</h2>
              </template>
              <template slot="content">

              <div class="mt-2 mb-4">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EnviarAvisos"
                  />
                  <label for="switch-enviar-avisos" class="sr-only">
                    {{$t('companies.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}
                  </label>
                  <el-switch 
                    id="switch-enviar-avisos"
                    :aria-label="$t('companies.active')"
                    class="switch-text break-normal" 
                    v-model="form.EnviarAvisos" 
                    :active-text="$t('companies.active')"></el-switch>
                </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoNueva"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-nueva" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_alerts')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-nueva"
                        :aria-label="$t('companies.email_alerts')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoNueva" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                    <el-form-item prop="EmailAvisoNueva">
                      <el-input
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoNueva"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoDescargada"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-descargada" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_downloads')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-descargada"
                        :aria-label="$t('companies.email_downloads')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoDescargada" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoDescargada">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoDescargada"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoTramitada"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-tramitada" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_tramitada')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-tramitada"
                        :aria-label="$t('companies.email_tramitada')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoTramitada" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoTramitada">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoTramitada"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>
              
              <div class="lg:mb-0">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0">
                  <div class="mandatory flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.DiasAviso"
                    />
                    <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.download_alert_days_form')}}
                      <el-form-item prop="DiasAviso" class="mb-0">
                        <el-input
                          clearable
                          v-model="form.DiasAviso"
                          maxlength='5'
                          :placeholder="$t('configurations.default_disabled')"
                        />
                      </el-form-item>
                    </label>
                    </div>
                  </div>
                </div>
                  <div class="px-2 w-full lg:mb-0 flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.DiasFinTramite"
                    />
                    <div class="w-full">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.end_alert_days_label_form')}}
                        <el-form-item prop="DiasFinTramite" class="mb-0">
                          <el-input
                            clearable
                            v-model="form.DiasFinTramite"
                            maxlength='5'
                            :placeholder="$t('configurations.default_disabled')"
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mt-5 mb-5 mr-20 flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.AgruparEmailsAvisos"
                  />
                  <label for="switch-agrupar-emails-avisos" class="sr-only">
                    {{$t('configurations.mails_group_status')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.mails_group_status')}}
                  </label>
                  <el-switch 
                    id="switch-agrupar-emails-avisos"
                    :aria-label="$t('configurations.mails_group_status')"
                    class="switch-text break-normal" 
                    v-model="form.AgruparEmailsAvisos" 
                    :active-text="$t('configurations.mails_group_status')"></el-switch>
                  </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoUltimaLlamada"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <div class="w-full">
                        <label for="switch-email-aviso-ultima-llamada" v-if="form.AgruparEmailsAvisos" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('companies.mails_group_status_input')}}
                          <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                        </label>
                        <label for="switch-email-aviso-ultima-llamada" v-else class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('companies.email_ultima_llamada')}}
                          <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                        </label>
                      </div>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-ultima-llamada"
                        :aria-label="form.AgruparEmailsAvisos ? $t('companies.mails_group_status_input') : $t('companies.email_ultima_llamada')"
                        class="switch-text break-normal both-switch" 
                        v-model="valuesAdd.EmailAvisoUltimaLlamada" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                    <el-form-item prop="EmailAvisoUltimaLlamada">
                      <el-input
                        clearable
                        v-model="form.EmailAvisoUltimaLlamada"
                        maxlength='500'
                      />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="" v-if="form.AgruparEmailsAvisos === false">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoTramitacionUrgente"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-tramitacion-urgente" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_tramitacion_urgente')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-tramitacion-urgente"
                        :aria-label="$t('companies.email_tramitacion_urgente')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoTramitacionUrgente" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoTramitacionUrgente">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoTramitacionUrgente"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>
              <div class="" v-if="form.AgruparEmailsAvisos === false">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailAvisoErrores"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-aviso-errores" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_neos_error')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-aviso-errores"
                        :aria-label="$t('companies.email_neos_error')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailAvisoErrores" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailAvisoErrores">
                    <el-input
                      clearable
                      v-model="form.EmailAvisoErrores"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>

              <div class="">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.EmailTecnico"
                  />
                  <div class="w-full">
                    <div class="flex items-center justify-between">
                      <label for="switch-email-tecnico" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('companies.email_tech')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.add')}} / {{$t('configurations.sustitute')}}</span>
                      </label>
                      <el-switch 
                        v-if="!modeTemplate"
                        id="switch-email-tecnico"
                        :aria-label="$t('companies.email_tech')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="valuesAdd.EmailTecnico" 
                        :inactive-text="$t('configurations.add')"
                        :active-text="$t('configurations.sustitute')" 
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                  <el-form-item prop="EmailTecnico">
                    <el-input
                      clearable
                      v-model="form.EmailTecnico"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
                </div>
              </div>

              </template>
            </base-collapsible-form>

         
          <!-- <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('companies.automatic_download')}}</h2> -->

          <base-collapsible-form 
            ref="baseCollapsibleWhiteMetadata" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.automatic_download')}}</h2>
            </template>
            <template slot="content">

                <div class="mb-4">
                <div class="mandatory flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.DescargaAutomatica"
                  />
                  <label for="switch-descarga-automatica" class="sr-only">
                    {{$t('configurations.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.active')}}
                  </label>
                  <el-switch 
                    id="switch-descarga-automatica"
                    :aria-label="$t('configurations.active')"
                    class="switch-text break-normal" 
                    v-model="form.DescargaAutomatica" 
                    :active-text="$t('configurations.active')"></el-switch>
                </div>
              </div>
              <div class="lg:mb-4 flex items-center">
                  <input
                    v-if="!modeTemplate"
                    class='k-checkbox !mr-2 checkbox-lg'
                    type='checkbox'
                    v-model="valuesCheckbox.DiasDescargaAutomatica"
                  />
                  <div class="w-full">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.automatic_download_days_label')}}
                    <el-form-item prop="DiasDescargaAutomatica">
                      <el-input
                        clearable
                        v-model="form.DiasDescargaAutomatica"
                        maxlength='5'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

            </template>
          </base-collapsible-form>

          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('configurations.change_mode_template_edit')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_companies')" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_companies')" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
            >
            <p>Se han preseleccionado</p>
            <p>las empresas seleccionadas. </p>
          </el-popover>
        </template>
      </base-footer>
      <template-link-Companies-dialog 
        ref="templatelinkcompaniesdialog" 
        :title="titleLinkCompanies" 
        :clientId="this.id" 
        :modeTemplate="modeTemplate" 
        :dialogOpen="linkToCompaniesDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { getCompanyTemplate } from '@/services/app/getCompanyTemplate'
import { updateCompanyTemplate } from '@/services/app/updateCompanyTemplate'
import { applyCompanyTemplate } from '@/services/app/applyCompanyTemplate'
import { applyCompanyKeys } from '@/services/app/applyCompanyKeys'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import TemplateLinkCompaniesDialog from '@/components/TemplateLinkCompaniesDialog.vue'
import moment from 'moment'

import { getClient } from '@/services/clients/getClient'

function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}
function isValidDay (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 8) {
      return true
    }
  }
  return false
}
function isValidDayDownload (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 10) {
      return true
    }
  }
  return false
}
function isValidDayEnd (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 30) {
      return true
    }
  }
  return false
}
export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkCompaniesDialog,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      enableEditCampos: true,
      searchView: false,
      linkToCompaniesDialog: false,
      tooltipfechaInicioVig: this.$i18n.t('tooltip.fechaInicioVig'),
      activeName: 'es',
      header: {
        title: i18n.t('configurations.template_header_text'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations'
      },
      checkall: false,
      valuesCheckbox: {
        fechaInicioVig: false,
        EmailAvisoNueva: false,
        EmailAvisoDescargada: false,
        EmailAvisoTramitada: false,
        AgruparEmailsAvisos: false,
        EmailAvisoUltimaLlamada: false,
        EmailAvisoTramitacionUrgente: false,
        EmailAvisoErrores: false,
        EmailTecnico: false,
        DescargaAutomatica: false,
        EnviarAvisos: false,
        Activo: false,
        DiasAviso: false,
        DiasDescargaAutomatica: false,
        DiasFinTramite: false,
      },
      valuesAdd: {
        EmailAvisoNueva: true,
        EmailAvisoDescargada: true,
        EmailAvisoTramitada: true,
        EmailAvisoUltimaLlamada: true,
        EmailAvisoTramitacionUrgente: true,
        EmailAvisoErrores: true,
        EmailTecnico: true,
      },
      form: {
        EmailAvisoNueva: null,
        EmailAvisoDescargada: null,
        EmailAvisoTramitada: null,
        AgruparEmailsAvisos: false,
        EmailAvisoUltimaLlamada: '',
        EmailAvisoTramitacionUrgente: '',
        EmailAvisoErrores: '',
        EmailTecnico: null,
        DescargaAutomatica: false,
        EnviarAvisos: false,
        Activo: true,
        DiasAviso: null,
        DiasDescargaAutomatica: 0,
        DiasFinTramite: null,
        IdEmpresa: null,
        fechaInicioVig: '',
        IdPlantilla: 0
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        EmailAvisoNueva: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoDescargada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoTramitada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoUltimaLlamada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoTramitacionUrgente: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoErrores: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailTecnico: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        DiasDescargaAutomatica: [
          { required: false, validator: this.isDayValidDownload, trigger: 'blur' }
        ],
        DiasAviso: [
          { required: false, validator: this.isDayValid, trigger: 'blur' }
        ],
        DiasFinTramite: [
          { required: false, validator: this.isDayValidEnd, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkCompanies () {
      return this.modeTemplate ? 'Aplicar plantilla a empresas' : 'Aplicar campos seleccionados a empresas'
    },
    id () {
      return this.$route.params.id ? this.$route.params.id : -1
    },
    isFromClient () {
      return this.id !== -1
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    'valuesCheckbox.EmailAvisoUltimaLlamada' (value, oldValue) {
      if (value) this.valuesCheckbox.AgruparEmailsAvisos = true
    },
    'valuesCheckbox.EmailAvisoTramitacionUrgente' (value, oldValue) {
      if (value) this.valuesCheckbox.AgruparEmailsAvisos = true
    },
    'valuesCheckbox.EmailAvisoErrores' (value, oldValue) {
      if (value) this.valuesCheckbox.AgruparEmailsAvisos = true
    },
    'valuesCheckbox.AgruparEmailsAvisos' (value, oldValue) {
      if (!value) {
        this.valuesCheckbox.EmailAvisoUltimaLlamada = false
        this.valuesCheckbox.EmailAvisoTramitacionUrgente = false
        this.valuesCheckbox.EmailAvisoErrores = false
      }
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = this.$i18n.t('configurations.template_header_text_mode')
      else this.header.title = this.$i18n.t('configurations.template_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      
      const cliente = await this.downloadClientData(this.id)
      breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectCompanies()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template.respuesta)
    }
    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
    this.resetControlFormChanges()
  },
  methods: {
    preSelectCompanies () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.companies) {
        this.$refs.templatelinkcompaniesdialog.changeSelectedCompanies(data.companies)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.EmailAvisoNueva = value
      this.valuesCheckbox.EmailAvisoDescargada = value
      this.valuesCheckbox.EmailAvisoTramitada = value
      this.valuesCheckbox.AgruparEmailsAvisos= value
      this.valuesCheckbox.EmailAvisoUltimaLlamada = value
      this.valuesCheckbox.EmailAvisoTramitacionUrgente = value
      this.valuesCheckbox.EmailAvisoErrores = value
      this.valuesCheckbox.EmailTecnico = value
      this.valuesCheckbox.DescargaAutomatica = value
      this.valuesCheckbox.EnviarAvisos = value
      this.valuesCheckbox.Activo = value
      this.valuesCheckbox.DiasAviso = value
      this.valuesCheckbox.DiasDescargaAutomatica = value
      this.valuesCheckbox.DiasFinTramite = value
      this.valuesCheckbox.fechaInicioVig = value
    },
    toggleDialogLink: function () {
      this.linkToCompaniesDialog = !this.linkToCompaniesDialog
    },
    applyLinkHandler: async function (companies) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateCompanies('ruleForm', companies)
      } else {
        this.UpdateCompaniesWithSelected('ruleForm', companies)
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler: function ({ certificate, send_alerts, automatic_download, fechaInicioVig, AgruparEmailsAvisos }) {
      if (fechaInicioVig !== undefined && moment(fechaInicioVig).isValid()) {
        this.form.fechaInicioVig = moment(fechaInicioVig).format('YYYY-MM-DD')
      } else {
        this.form.fechaInicioVig = ''
      }
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (automatic_download !== undefined) {
        this.form.automatic_download = !!automatic_download
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
      // Control para ocultar las no visibles
      if (AgruparEmailsAvisos !== undefined && AgruparEmailsAvisos === true) {
        this.valuesCheckbox.EmailAvisoErrores = false
        this.valuesCheckbox.EmailAvisoTramitacionUrgente = false
      }
      this.$store.commit('app/setFormChanges', true)
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email_multiple'), callback)
      } else {
        callback()
      }
    },
    isDayValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDay(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso'), callback)
      } else {
        callback()
      }
    },
    isDayValidDownload: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayDownload(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_download'), callback)
      } else {
        callback()
      }
    },
    isDayValidEnd: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayEnd(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_fin_tramite'), callback)
      } else {
        callback()
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EmailTecnico: this.form.EmailTecnico,
            DescargaAutomatica: this.form.DescargaAutomatica,
            EnviarAvisos: this.form.EnviarAvisos,
            Activo: this.form.Activo,
            DiasAviso: this.form.DiasAviso,
            DiasDescargaAutomatica: this.form.DiasDescargaAutomatica,
            DiasFinTramite: this.form.DiasFinTramite,
            IdEmpresa: this.form.IdEmpresa,
            IdPlantilla: this.form.IdPlantilla,
            FechaInicioVigilancia: this.form.fechaInicioVig ? moment(this.form.fechaInicioVig).format('YYYY-MM-DD[T00:00:00]') : null,
          }
          const response = await updateCompanyTemplate({ idEmpresa: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateCompanies: function (formName, companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EmailTecnico: this.form.EmailTecnico,
            DescargaAutomatica: this.form.DescargaAutomatica,
            EnviarAvisos: this.form.EnviarAvisos,
            Activo: this.form.Activo,
            DiasAviso: this.form.DiasAviso,
            DiasDescargaAutomatica: this.form.DiasDescargaAutomatica,
            DiasFinTramite: this.form.DiasFinTramite,
            IdEmpresa: this.form.IdEmpresa,
            IdPlantilla: this.form.IdPlantilla,
            FechaInicioVigilancia: this.form.fechaInicioVig ? moment(this.form.fechaInicioVig).format('YYYY-MM-DD[T00:00:00]') : null,
          }
          this.toggleDialogLink()
          const response = await updateCompanyTemplate({ idEmpresa: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Plantilla guardada correctamente', 'success')
            this.resetControlFormChanges()
            const response = await applyCompanyTemplate({ idEmpresa: this.id }, companies)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Empresas actualizadas correctamente', 'success')
            }
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateCompaniesWithSelected: function (formName, companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            idCIFEmpresas: companies,

            checkEmailAvisoNueva: this.valuesCheckbox.EmailAvisoNueva,
            checkEmailAvisoDescargada: this.valuesCheckbox.EmailAvisoDescargada,
            checkEmailAvisoTramitada: this.valuesCheckbox.EmailAvisoTramitada,
            checkEmailDiasAviso: this.valuesCheckbox.EmailAvisoUltimaLlamada,
            checkEmailAvisoTramitacionUrgente: this.valuesCheckbox.EmailAvisoTramitacionUrgente,
            checkEmailAvisoErrores: this.valuesCheckbox.EmailAvisoErrores,
            checkAgruparEmailsAvisos: this.valuesCheckbox.AgruparEmailsAvisos,
            checkEmailTecnico: this.valuesCheckbox.EmailTecnico,
            checkDescargaAutomatica: this.valuesCheckbox.DescargaAutomatica,
            checkEnviarAvisos: this.valuesCheckbox.EnviarAvisos,
            checkActivo: this.valuesCheckbox.Activo,
            checkDiasAviso: this.valuesCheckbox.DiasAviso,
            checkDiasDescargaAutomatica: this.valuesCheckbox.DiasDescargaAutomatica,
            checkDiasFinTramite: this.valuesCheckbox.DiasFinTramite,
            checkFechaInicioVigilancia: this.valuesCheckbox.fechaInicioVig,

            addEmailAvisoNueva: !this.valuesAdd.EmailAvisoNueva,
            addEmailAvisoDescargada: !this.valuesAdd.EmailAvisoDescargada,
            addEmailAvisoTramitada: !this.valuesAdd.EmailAvisoTramitada,
            addEmailDiasAviso: !this.valuesAdd.EmailAvisoUltimaLlamada,
            addEmailAvisoTramitacionUrgente: !this.valuesAdd.EmailAvisoTramitacionUrgente,
            addEmailAvisoErrores: !this.valuesAdd.EmailAvisoErrores,
            addEmailTecnico: !this.valuesAdd.EmailTecnico,

            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EmailTecnico: this.form.EmailTecnico,
            DescargaAutomatica: this.form.DescargaAutomatica,
            EnviarAvisos: this.form.EnviarAvisos,
            Activo: this.form.Activo,
            DiasAviso: this.form.DiasAviso,
            DiasDescargaAutomatica: this.form.DiasDescargaAutomatica,
            DiasFinTramite: this.form.DiasFinTramite,
            IdEmpresa: this.form.IdEmpresa,
            IdPlantilla: this.form.IdPlantilla,
            FechaInicioVigilancia: this.form.fechaInicioVig ? moment(this.form.fechaInicioVig).format('YYYY-MM-DD[T00:00:00]') : null
          }
          this.toggleDialogLink()
          const response = await applyCompanyKeys({ idEmpresa: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Empresas actualizadas correctamente', 'success')
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
      else this.$router.push({ name: 'companies' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getCompanyTemplate({ idEmpresa: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (template) {
      if (template) {
        this.form.EmailAvisoNueva = template.EmailAvisoNueva ? template.EmailAvisoNueva : null
        this.form.EmailAvisoDescargada = template.EmailAvisoDescargada ? template.EmailAvisoDescargada : null
        this.form.EmailAvisoTramitada = template.EmailAvisoTramitada ? template.EmailAvisoTramitada : null
        this.form.EmailAvisoUltimaLlamada = template.EmailDiasAviso ? template.EmailDiasAviso : null
        this.form.EmailAvisoTramitacionUrgente = template.EmailAvisoTramitacionUrgente ? template.EmailAvisoTramitacionUrgente : null
        this.form.EmailAvisoErrores = template.EmailAvisoErrores ? template.EmailAvisoErrores : null
        this.form.AgruparEmailsAvisos = template.AgruparEmailsAvisos ? template.AgruparEmailsAvisos : false
        this.form.EmailTecnico = template.EmailTecnico ? template.EmailTecnico : null
        this.form.DescargaAutomatica = template.DescargaAutomatica ? template.DescargaAutomatica : null
        this.form.EnviarAvisos = template.EnviarAvisos ? template.EnviarAvisos : null
        this.form.Activo = template.Activo ? template.Activo : null
        this.form.DiasAviso = template.DiasAviso !== null || template.DiasAviso !== undefined ? template.DiasAviso : null
        this.form.DiasAvisoFinTramite = template.DiasFinTramite !== null || template.DiasFinTramite !== undefined ? template.DiasFinTramite : null
        this.form.DiasDescargaAutomatica = template.DiasDescargaAutomatica ? template.DiasDescargaAutomatica : 0
        this.form.IdEmpresa = template.IdEmpresa ? template.IdEmpresa : null
        this.form.IdPlantilla = template.IdPlantilla ? template.IdPlantilla : null
        this.form.fechaInicioVig = template.FechaInicioVigilancia ? template.FechaInicioVigilancia : null
      }
      this.resetControlFormChanges()
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
